import styled from 'styled-components';

import {
  colorBlack900,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
} from '@/styleUtils';

export const Wrapper = styled.div`
  background-color: ${colorWhite};
  padding: 24px;
  border-radius: 12px;
`;

export const IconWrapper = styled.div`
  width: 48px;
  margin: 0 auto 16px;
`;

export const Title = styled.h2`
  font-family: ${fontFamilySecondary};
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: ${colorBlack900};
  margin: 0 0 8px;
`;

export const Description = styled.p`
  font-family: ${fontFamilyPrimary};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: ${colorBlack900};
`;

export const Handler = styled.button`
  display: block;
  font-family: ${fontFamilySecondary};
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: ${colorPrimary400};
  border: none;
  background: transparent;
  margin: 16px auto;
  outline: none;
  transition: 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;
